import { decorate, observable } from "mobx";

class Permissions {
  permissions = {
    can_change_settings: 0,
    can_share: 0,
    can_view: 0,
    can_view_criteria: "",
    can_add: 0,
    can_edit: 0,
    can_export: 0,
    can_send_email: 0,
    can_edit_criteria: "",
    can_delete: 0,
    can_delete_criteria: "",
    hidden_fields: "",
    noneditable_fields: "",
  };

  constructor(permissions) {
    if (permissions) {
      this.permissions = { ...this.permissions, ...permissions };
    }
    return this;
  }

  getPermissions() {
    return this.permissions;
  }

  canChangeSettings = function () {
    return this.getPermissions().can_change_settings > 0;
  };

  canShare = function () {
    return this.getPermissions().can_change_settings > 0; //can_share
  };

  canView = function () {
    return this.getPermissions().can_view > 0;
  };

  canAdd = function () {
    return this.getPermissions().can_add > 0;
  };

  canExport = function () {
    return this.getPermissions().can_export > 0;
  };

  canSendEmail = function () {
    return this.getPermissions().can_send_email > 0;
  };

  canEdit = function (colId, row) {
    if (this.getPermissions().can_edit == 0) {
      return [false, "You don't have permission to edit any row or any field"];
    } else if (this.getPermissions().can_edit == 1) {
      if (this.getNonEditableColumns().includes(colId)) {
        return [false, "You don't have permission to edit this field"];
      } else {
        return [true];
      }
    } else if (
      this.getPermissions().can_edit == 2 ||
      this.getPermissions().can_edit == 3
    ) {
      if (
        this.getNonEditableColumns().includes(colId) &&
        (row?.is_row_editable == 0 || row?.is_row_editable === null)
      ) {
        return [
          false,
          "You don't have permission to edit this field and this row",
        ];
      } else if (row?.is_row_editable == 0 || row?.is_row_editable === null) {
        return [false, "You don't have permission to edit this row"];
      } else if (this.getNonEditableColumns().includes(colId)) {
        return [false, "You don't have permission to edit this field"];
      } else {
        return [true];
      }
    }
  };

  canModifyColumn = function (action, columnId) {
    if (action === "add") {
      return this.canAddColumn(columnId);
    } else {
      return this.canEditColumn(columnId);
    }
  };

  canEditColumn = function (columnId) {
    var nonEditableColumns = this.getNonEditableColumns();

    if (nonEditableColumns.indexOf(columnId) > -1) {
      return false;
    } else {
      return true;
    }
  };

  canAddColumn = function (columnId) {
    var nonEditableColumns = this.getNonAddableColumns();

    if (nonEditableColumns.indexOf(columnId) > -1) {
      return [false, "You don't have permission to add this column"];
    } else {
      return [true];
    }
  };

  getNonEditableColumns = function () {
    var fields = this.getPermissions().noneditable_fields;

    if (fields != "") {
      return fields.split(",");
    } else {
      return [];
    }
  };

  getNonAddableColumns = function () {
    var fields = this.getPermissions().nonaddable_fields;

    if (fields != "") {
      return fields.split(",");
    } else {
      return [];
    }
  };

  canDelete = function () {
    return this.getPermissions().can_delete > 0;
  };

  isAdmin = function () {
    return this.canChangeSettings();
  };
}

decorate(Permissions, {
  permissions: observable,
});

export default Permissions;
